/* Dashboard PRO V2 — Sprint 6.A */

.hero {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 28px;
  gap: 16px;
  flex-wrap: wrap;
}

.heroDate {
  font-family: var(--mono);
  font-size: 11px;
  font-weight: 600;
  color: var(--mute);
  letter-spacing: 1px;
  text-transform: uppercase;
}

.heroTitle {
  font-family: var(--display);
  font-weight: 800;
  font-size: 32px;
  letter-spacing: -1px;
  margin: 0;
  line-height: 1.05;
  color: var(--ink);
}

.heroTitle em {
  font-style: italic;
  font-weight: 700;
  color: var(--role-accent);
}

.heroSub {
  font-size: 14px;
  color: var(--ink-3);
  margin-top: 6px;
}

.heroSub b {
  font-weight: 600;
  color: var(--ink);
}

.heroSubAccent {
  font-weight: 600;
  color: var(--role-accent-deep);
}

.heroActions {
  display: flex;
  gap: 8px;
}

.pillBtn {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 999px;
  padding: 7px 13px;
  font-size: 12.5px;
  color: var(--ink-2);
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.pillBtn:hover {
  background: var(--surface-2);
}

.pillBtnActive {
  background: var(--ink);
  color: #fff;
  border-color: var(--ink);
}

.pillBtnActive:hover {
  background: var(--ink-2);
}

/* KPIs */
.kpis {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 28px;
}

.kpi {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 18px 20px;
  position: relative;
  overflow: hidden;
}

.kpiLabel {
  font-size: 11.5px;
  font-weight: 500;
  color: var(--mute);
  letter-spacing: 0.1px;
}

.kpiVal {
  font-family: var(--display);
  font-weight: 800;
  font-size: 36px;
  letter-spacing: -1.4px;
  margin-top: 6px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.kpiUnit {
  font-size: 22px;
  color: var(--mute);
  margin-left: 2px;
  font-weight: 800;
}

.kpiDelta {
  font-family: var(--mono);
  font-size: 11px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 10px;
  padding: 2px 7px;
  border-radius: 5px;
}

.kpiDeltaUp {
  background: var(--green-soft);
  color: var(--green-deep);
}

.kpiDeltaDown {
  background: #fbe5e5;
  color: var(--red);
}

.kpiDeltaNeutral {
  background: var(--surface-2);
  color: var(--mute);
}

.kpiIconBg {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Grid layouts */
.gridMain {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.gridSecond {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.gridThird {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 1280px) {
  .gridMain { grid-template-columns: 1fr; }
  .gridSecond { grid-template-columns: 1fr; }
  .gridThird { grid-template-columns: 1fr; }
}

/* Card */
.card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 14px;
}

.cardHeader {
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--line-3);
  gap: 12px;
}

.cardTitle {
  font-family: var(--display);
  font-weight: 700;
  font-size: 14.5px;
  letter-spacing: -0.3px;
  color: var(--ink);
}

.cardSub {
  font-size: 11.5px;
  color: var(--mute);
  margin-top: 2px;
}

.ghostBtn {
  border: 0;
  background: transparent;
  color: var(--mute);
  padding: 5px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}

.ghostBtn:hover {
  background: var(--surface-2);
  color: var(--ink);
}

.seg {
  display: flex;
  background: var(--surface-2);
  border: 1px solid var(--line);
  border-radius: 8px;
  padding: 2px;
}

.segBtn {
  border: 0;
  background: transparent;
  padding: 4px 10px;
  font-size: 11.5px;
  font-weight: 500;
  color: var(--mute);
  border-radius: 6px;
  cursor: pointer;
}

.segBtnActive {
  background: var(--surface);
  color: var(--ink);
  box-shadow: var(--shadow-sm);
}

/* Roster table */
.roster {
  padding: 8px 0 4px;
  overflow-x: auto;
}

.rosterTable {
  width: 100%;
  border-collapse: collapse;
}

.rosterTable th {
  font-family: var(--mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1.2px;
  color: var(--mute);
  text-transform: uppercase;
  padding: 10px 20px;
  text-align: left;
  border-bottom: 1px solid var(--line-3);
}

.rosterTable td {
  padding: 14px 20px;
  border-bottom: 1px solid var(--line-3);
  font-size: 13px;
  vertical-align: middle;
}

.rosterTable tbody tr:last-child td {
  border-bottom: 0;
}

.rosterTable tbody tr:hover {
  background: var(--surface-2);
}

/* Patient/Athlete cell */
.pt {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ptAv {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--display);
  font-weight: 800;
  font-size: 11.5px;
  color: #fff;
  letter-spacing: -0.4px;
  flex-shrink: 0;
}

.ptName {
  font-weight: 600;
  color: var(--ink);
  font-size: 13px;
}

.ptMeta {
  font-family: var(--mono);
  font-size: 10.5px;
  color: var(--mute);
  margin-top: 1px;
  letter-spacing: 0.2px;
}

/* Status badges */
.statusBadge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 999px;
  font-family: var(--mono);
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.statusActive {
  background: var(--green-soft);
  color: var(--green-deep);
}

.statusAttention {
  background: var(--orange-soft);
  color: var(--orange-deep);
}

.statusPaused {
  background: var(--surface-2);
  color: var(--mute);
  border: 1px solid var(--line);
}

.statusNew {
  background: var(--blue-soft);
  color: var(--blue-deep);
}

.statusLive {
  background: rgba(11, 138, 62, .12);
  color: var(--green-deep);
}

.statusDeload {
  background: var(--purple-soft);
  color: var(--purple);
}

.statusDot {
  width: 5px;
  height: 5px;
  border-radius: 3px;
}

.statusLive .statusDot {
  animation: pulse 1.4s infinite;
}

@keyframes pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(11, 138, 62, .5); }
  50% { box-shadow: 0 0 0 4px rgba(11, 138, 62, 0); }
}

/* Adherence bar */
.adhBar {
  width: 100%;
  max-width: 110px;
  height: 5px;
  background: var(--line-2);
  border-radius: 3px;
  overflow: hidden;
}

.adhBar > div {
  height: 100%;
  border-radius: 3px;
}

.adhCell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.num {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  font-size: 12.5px;
  color: var(--ink-2);
}

.trendUp { color: var(--green-deep); }
.trendDown { color: var(--red); }
.numMute { color: var(--mute); }
.numLive {
  color: var(--green-deep);
  font-weight: 700;
}

.rowAction {
  color: var(--mute);
  padding: 4px;
  border-radius: 6px;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.rowAction:hover {
  background: var(--surface-2);
  color: var(--ink);
}

/* Empty / loading */
.empty {
  padding: 32px 24px;
  text-align: center;
  color: var(--mute);
  font-size: 13px;
}

.errorBox {
  padding: 20px;
  background: #fbe5e5;
  color: var(--red);
  border-radius: 12px;
  border: 1px solid #f4b8b8;
  margin: 16px 0;
  font-size: 13px;
}

/* Live athletes (coach) */
.liveAthletes {
  padding: 8px 16px 16px;
}

.liveRow {
  display: grid;
  grid-template-columns: 36px 1fr auto auto;
  gap: 10px;
  align-items: center;
  padding: 12px 4px;
  border-bottom: 1px solid var(--line-3);
}

.liveRow:last-child {
  border-bottom: 0;
}

.liveAv {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--display);
  font-weight: 800;
  color: #fff;
  position: relative;
}

.liveAv::after {
  content: '';
  position: absolute;
  inset: -3px;
  border-radius: 50%;
  border: 2px solid var(--green);
  animation: ring 1.6s infinite ease-out;
}

@keyframes ring {
  0% { opacity: 1; transform: scale(1); }
  100% { opacity: 0; transform: scale(1.18); }
}

.liveCur {
  font-family: var(--mono);
  font-size: 11px;
  color: var(--mute);
  margin-top: 2px;
  letter-spacing: 0.2px;
}

.liveProg {
  width: 60px;
}

.liveProgLabel {
  font-family: var(--mono);
  font-size: 10px;
  color: var(--mute);
  text-align: right;
  margin-top: 3px;
  font-weight: 600;
}

.liveBpm {
  text-align: right;
}

.liveBpmNum {
  font-family: var(--display);
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.3px;
  font-variant-numeric: tabular-nums;
}

.liveBpmLbl {
  font-family: var(--mono);
  font-size: 9.5px;
  color: var(--mute);
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Feed & alerts */
.feed {
  padding: 8px 16px 16px;
}

.feedItem {
  display: flex;
  gap: 12px;
  padding: 10px 4px;
  border-bottom: 1px solid var(--line-3);
}

.feedItem:last-child {
  border-bottom: 0;
}

.feedDot {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feedBody {
  flex: 1;
  min-width: 0;
}

.feedText {
  font-size: 12.5px;
  color: var(--ink-2);
  line-height: 1.45;
}

.feedText b {
  font-weight: 600;
  color: var(--ink);
}

.feedTime {
  font-family: var(--mono);
  font-size: 10px;
  color: var(--mute);
  margin-top: 3px;
  letter-spacing: 0.4px;
}

.alertRow {
  display: flex;
  gap: 11px;
  padding: 10px 4px;
  border-bottom: 1px solid var(--line-3);
  align-items: flex-start;
}

.alertRow:last-child {
  border-bottom: 0;
}

.alertIcon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alertTitle {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--ink);
  line-height: 1.3;
}

.alertMeta {
  font-size: 11.5px;
  color: var(--mute);
  margin-top: 3px;
  line-height: 1.35;
}

/* Heatmap */
.heatmap {
  padding: 14px 20px 18px;
}

.heatmapRow {
  display: grid;
  grid-template-columns: 110px repeat(7, 1fr);
  gap: 4px;
  align-items: center;
  padding: 5px 0;
}

.heatmapLbl {
  font-size: 12px;
  font-weight: 600;
  color: var(--ink-2);
  display: flex;
  align-items: center;
  gap: 7px;
}

.heatmapLbl .ptAv {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  font-size: 9px;
}

.heatmapCell {
  height: 30px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--mono);
  font-size: 10px;
  font-weight: 700;
  color: var(--ink);
}

.heatmapCellEmpty {
  background: var(--line-3);
}

.heatmapHead {
  display: grid;
  grid-template-columns: 110px repeat(7, 1fr);
  gap: 4px;
  padding-bottom: 8px;
}

.heatmapHead > div {
  text-align: center;
  font-family: var(--mono);
  font-size: 9.5px;
  font-weight: 600;
  color: var(--mute);
  letter-spacing: 0.6px;
}

.heatmapHead > div:first-child {
  text-align: left;
}

/* Volume chart (bar chart simple) */
.barChart {
  padding: 14px 20px 18px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
  height: 160px;
}

.barCol {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.barFill {
  width: 100%;
  max-width: 32px;
  background: var(--role-accent);
  border-radius: 4px 4px 0 0;
  min-height: 4px;
  transition: height 0.3s;
}

.barLabel {
  font-family: var(--mono);
  font-size: 10px;
  color: var(--mute);
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.barValue {
  font-family: var(--display);
  font-size: 11px;
  font-weight: 700;
  color: var(--ink);
}

/* Top PR list */
.prList {
  display: flex;
  flex-direction: column;
  padding: 8px 20px 18px;
}

.prRow {
  display: grid;
  grid-template-columns: 24px 1fr auto auto;
  gap: 12px;
  align-items: center;
  padding: 11px 0;
  border-bottom: 1px solid var(--line-3);
}

.prRow:last-child {
  border-bottom: 0;
}

.prRank {
  font-family: var(--mono);
  font-size: 11px;
  color: var(--mute);
  font-weight: 700;
  text-align: center;
}

.prValue {
  font-family: var(--display);
  font-weight: 800;
  font-size: 18px;
  letter-spacing: -0.4px;
  font-variant-numeric: tabular-nums;
}

.prValueUnit {
  font-size: 11px;
  color: var(--mute);
  margin-left: 2px;
}

.prDelta {
  font-family: var(--mono);
  font-size: 11px;
  font-weight: 600;
  background: var(--green-soft);
  color: var(--green-deep);
  padding: 2px 7px;
  border-radius: 5px;
}
